import React from 'react';
import {AisinoDatePicker, AisinoFormItem} from "../../../baseComponent/form";
import {formItemTailLayout} from "../../../constant/css";
import {getDatePickerLanguage} from "../../../source/js/common";

const locale = getDatePickerLanguage();
class FormItemDatePicker extends React.Component {
    constructor(props){
        super(props);
        let dateFormatter=sessionStorage.getItem("dateFormatter");
        let defaultDf='YYYY-MM-DD';
        if(props.picker==="month"){
            dateFormatter='YYYY-MM';
        }
        if(props.showTime){
            dateFormatter=sessionStorage.getItem("timeFormatter");
        }
        this.state={
            dateFormatStr:dateFormatter?dateFormatter:defaultDf,
        };
    }
    render() {
        let styleBg = false
        this.props.rules?this.props.rules.forEach(item=>{
            if(item.required){
                styleBg = item.required
            }
        }):"";
        return(
            <AisinoFormItem {...formItemTailLayout} {...this.props}>
                <AisinoDatePicker
                    {...this.props}
                    style={styleBg?{background:"#ffffe6"}:{}}
                    format={this.props.format?this.props.format:this.state.dateFormatStr}
                    locale={locale}
                    inputReadOnly={true}
                    allowClear={this.props.allowClear !== undefined ? this.props.allowClear : true}
                />
            </AisinoFormItem>
        );
    }
}

export default FormItemDatePicker;
